/**
 * Whose work this is. Bumped (by the Hub store) whenever the person this tab
 * works for changes or leaves: a sign-out, another person's session, a vault
 * that isn't theirs. Any work begun before then (a session check, a vault
 * unlock, a password change, a key published, a list fetched or decrypted)
 * finishes into nothing: take `sessionStill()` before the first wait and
 * check it after every one, before writing anything.
 */
let sessionEpoch = 0;
export function sessionStill() {
    const epoch = sessionEpoch;
    return () => epoch === sessionEpoch;
}
/** Ends every piece of work begun for the person who was here. */
export function endSessionWork() {
    sessionEpoch += 1;
}
